/* tslint:disable */
/* eslint-disable */
export enum WorkWorkflowActionsStandardtaskEnum {
  Start = 'start',
  End = 'end'
}
